



























































































import Vue from "vue";
import Modal from "@/components/root/modal/Modal.vue";
import { ModalConfig } from "@/components/root/modal";
import { computed, onMounted, ref } from "@vue/composition-api";
import DropDownSimple from "@/components/dropdown/DropDownSimple.vue";
import { UseDropdownItems } from "@/common/composition/dropdown-items";
import { SourceStartParams } from "../data/data-relations/start-params.map";
import * as api from "../data/datasources.api";
import Spinner from "@/components/Spinner.vue";
import { UseLoading } from "@/common/composition/loading";
import {
  DataSourceType,
  SessionInputDisplayParam,
  SourceBrief,
} from "../data/model";
import { Filters } from "@/common/filters.global";
import { UseParamsSchemeChecker } from "@/common/composition/use-param-scheme-checker";

import AzFIleShareSessionParamsVue from "./sources/AzFIleShareSessionParams.vue";
import AzStorageSessionParamsVue from "./sources/AzStorageSessionParams.vue";
export default Vue.extend({
  components: {
    Modal,
    DropDownSimple,
    Spinner,
  },
  props: ["modalData"],
  setup(props, { emit }) {
    const session_name = ref("");

    // ==== custom source params section
    const sources_with_custom_start_session_params = [
      "az_file_share",
      "az_storage",
    ] as DataSourceType[];

    const is_using_custom_source_session_params = computed(() => {
      // @ts-ignore
      const { id: source_id } = props.modalData.source;
      return sources_with_custom_start_session_params.includes(
        source_id as DataSourceType
      );
    });

    const custom_source_params_ui_cmp = ref(null);
    const custom_source_params = ref({ is_valid: false, params: {} });

    // ==== END custom source params section

    const config: ModalConfig = {
      title: "",
      desc: "",
      blank: true,
      width: "50rem",
      height: "auto",
      withTopRightCloseBtn: true,
    };

    const err_msg = ref("");

    const [
      connections,
      selected_connection,
      set_selected_connection,
      // @ts-ignore
    ] = UseDropdownItems(props.modalData.connections);

    const get_inputs = (): HTMLInputElement[] =>
      Array.from(document.querySelectorAll(".kv-field")) as HTMLInputElement[];

    const is_input_valid = computed(() => {
      const is_name_ok = session_name.value.trim().length > 0;

      if (is_using_custom_source_session_params.value) {
        return custom_source_params.value.is_valid && is_name_ok;
      }

      if (source.value.startParams.length === 0) {
        return is_name_ok;
      } else {
        return props_checker.is_valid.value && is_name_ok;
      }
    });
    const on_key_press = (filed_name: string, value: string) => {
      props_checker.update(filed_name, value);
      err_msg.value = "";
    };

    const [is_during_submit, set_is_during_submit] = UseLoading(false).as_arr();

    const submit_fields = async () => {
      set_is_during_submit(true);
      let start_params: Record<string, string> = {};
      if (is_using_custom_source_session_params.value) {
        start_params = custom_source_params.value.params;
      } else {
        const key_vals = get_inputs().map((d) => [d.name, d.value]);
        start_params = key_vals.reduce((acc, [k, v]) => {
          acc[k] = v;
          return acc;
        }, {} as Record<string, string>);
      }

      // @ts-ignore
      const source_id: string = props.modalData.source.id;
      // @ts-ignore
      const source_name: string = props.modalData.source.name;
      const payload = {
        source_id,
        connection_id: selected_connection.value!.id,
        start_params,
        session_name: session_name.value,
      };
      console.log("payload: ", payload);
      const start_session_res = await api.start_scan_session(payload);
      if (start_session_res.success) {
        emit("submit", {
          ...payload,
          session_id: start_session_res.value,
        });
      } else {
        const { code: err_code } = start_session_res;
        switch (err_code) {
          case 409:
            err_msg.value = `there is already an open session with the same setup!`;
            break;
          case 455:
            err_msg.value = `the ${source_name} auth system didn't approve your access`;
            break;
          case 422:
            const is_many = extended_start_params.value.length > 1;
            const attrs = extended_start_params.value
              .map((f) => f.display_name)
              .join(", ");
            err_msg.value = `<p>Please make sure your input for <b>${attrs}</b> ${
              is_many ? "are" : "is"
            } correct</p>`;
            break;
          default:
            err_msg.value = "Failed to start the scan :(";
            break;
        }
      }
      set_is_during_submit(false);
    };
    // @ts-ignore
    const source = computed(() => props.modalData.source as SourceBrief);

    const props_checker = UseParamsSchemeChecker(
      // @ts-ignore
      props.modalData.source.startParamsSchema?.properties || {}
    );

    const jsonSchemeTypeToInput = {
      string: "text",
      text: "text",
      integer: "number",
      number: "number",
    };

    const extended_start_params = computed((): SessionInputDisplayParam[] => {
      if (source.value.startParamsSchema) {
        return Object.entries(source.value.startParamsSchema.properties).map(
          (p: [string, any]) => {
            const [k, v] = p;
            return {
              ...v,
              desc: v.minimum
                ? `(${v.minimum} - ${Filters.num_suffix(v.maximum, 0)})`
                : "",
              display_name: v.description,
              name: k,
              // @ts-ignore
              type: jsonSchemeTypeToInput[v.type],
            };
          }
        );
      } else {
        return source.value.startParams
          .filter((d) => d)
          .map(
            (param: any): SessionInputDisplayParam =>
              SourceStartParams[param] || {
                name: param,
                display_name: param,
                type: "text",
                desc: "",
              }
          );
      }
    });

    /* 
      TODO:
      create a separate file that will take precedence over
      the keys that come in the start params
      and for azure file share will instruct 
      to have the
      - connection_name                     input(str)
      - session_name                        input(str)
      - sampling | full scan                radio buttons
      - all location | specific location    radio buttons
      - sampling rate (optional)            input(num)
      - specific location (optional)        input(str)    
    */

    onMounted(() => {
      const {
        // @ts-ignore
        connection_id,
      } = props.modalData;
      console.log("props.modalData::", props.modalData);

      if (connection_id) {
        set_selected_connection(connection_id);
      }
      if (is_using_custom_source_session_params.value) {
        // @ts-ignore
        switch (props.modalData.source.id as DataSourceType) {
          case "az_file_share":
            // @ts-ignore
            custom_source_params_ui_cmp.value = AzFIleShareSessionParamsVue;
            break;
          case "az_storage":
            // @ts-ignore
            custom_source_params_ui_cmp.value = AzStorageSessionParamsVue;
            break;
        }
      }
    });

    return {
      config,
      is_during_submit,
      err_msg,
      is_input_valid,
      on_key_press,
      props_status: props_checker.props_status,
      submit_fields,
      session_name,
      connections,
      selected_connection,
      set_selected_connection,
      extended_start_params,
      // custom source
      is_using_custom_source_session_params,
      custom_source_params_ui_cmp,
      custom_source_params,
    };
  },
});
